/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-types */
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { URL_ALLOW } from '@/constants';
import AuthContext from '@/contexts/auth';
import SchoolContext from '@/contexts/school';
import { useFirebaseAuth } from '@/hooks/useFirebaseAuth';
import { useFirebaseAuthUserAdmin } from '@/hooks/useFirebaseAuthUserAdmin';
import firebase from '@/plugins/firebaseConfig';
import { client } from '@/plugins/graphql';
import PaymentApi from '@/plugins/paymentApi';

export let unSubMeta: () => void;

export const useUserChanged = () => {
  const auth = getAuth(firebase);
  const router = useRouter();
  const { slug, schema, tenant_id } = useContext(SchoolContext);
  const { setAccessToken } = useContext(AuthContext);
  const { hasuraDefaultRoles, hasuraAllowRoles, setFbAuthCustomClaims } = useFirebaseAuthUserAdmin();
  const { getIdToken, getHasuraClaims } = useFirebaseAuth();

  auth.tenantId = tenant_id;

  const [processing, setProcessing] = useState(true);
  const [user, setUser] = useState<{
    uid: string;
    email: string | null;
    tenantId: string | null;
  } | null>(null);

  const updateMailaddress = ({ id, email }: { id: number; email: string }) => {
    const mutation = `
        mutation UpdateMailaddress {
          update_${schema}_user(
            where: {
              id: {_eq: ${id}}
            },
            _set: {
              email: "${email}"
            }
          ) {
            returning {
              email
            }
          }
        }
      `;

    try {
      return client.request(mutation);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const unSubUser = onAuthStateChanged(auth, async (user) => {
      setProcessing(true);

      // console.log('👨', user);
      if (user) {
        const { uid, email, tenantId } = user;

        const token = await getIdToken().catch((error) => {
          throw error;
        });

        setAccessToken(token as string);

        PaymentApi.getInstance().setToken(token as string);

        client.setHeaders({
          authorization: `Bearer ${token}`,
          'x-hasura-role': 'staff',
        });

        // console.log('authorized.');
        setUser({ uid, email, tenantId });
        const hasuraClaims: Object | undefined = await getHasuraClaims(user);

        if (!hasuraClaims) {
          // Hasura Claimsが存在していない場合、追加する
          await setFbAuthCustomClaims(uid, tenant_id);
        } else {
          let hasuraClaimCheckFlg = true;
          const hasuraValueArr: any[] = [];

          Object.values(hasuraClaims).map((v: string, i: number) => {
            hasuraValueArr[i] = v;
          });

          Object.keys(hasuraClaims).map((k: string, i: number) => {
            if (k == 'x-hasura-default-role') {
              if (hasuraValueArr[i] != hasuraDefaultRoles) hasuraClaimCheckFlg = false;
            } else if (k == 'x-hasura-allowed-roles') {
              if (hasuraValueArr[i]) {
                const roles = hasuraValueArr[i].join(',');
                const _roles = hasuraAllowRoles.join(',');
                if (roles != _roles) hasuraClaimCheckFlg = false;
              }
            }
          });

          // Hasura Claims が存在しているがロール設定がコード設定値と異なる場合、更新する
          if (!hasuraClaimCheckFlg) {
            await setFbAuthCustomClaims(uid, tenant_id);
          }
        }

        setProcessing(false);

        if (URL_ALLOW.includes(router.pathname)) {
          if (router.query.redirect) {
            router.push(`/${slug}/${router.query.redirect}`);
          } else {
            router.push(`/${slug}`);
          }
          setProcessing(false);
        }
      } else {
        if (!URL_ALLOW.includes(router.pathname)) {
          router.push(`/${slug}/login`);
        }
        setProcessing(false);
        setUser(null);
      }
    });

    return () => {
      unSubUser();
    };
  }, []);

  return {
    user,
    processing,
    updateMailaddress,
  };
};
